
import { Outlet } from 'react-router-dom';
import ContainerPresencaBatismo from './components/container';
import { ProviderPresenvaBatismo } from './context/getMembros';

export default function Presenca() {
  return (
    <>
      <ProviderPresenvaBatismo>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerPresencaBatismo />
        </div>
        <Outlet />
      </ProviderPresenvaBatismo>
    </>
  )
}
